import React, {useState} from 'react';
import styled from 'styled-components';
import {chromeMajorVersion} from '../../../util/chromeVersion';

const CHROME_UPDATE_URL = 'https://support.google.com/chrome/answer/95414';

const Banner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    box-sizing: border-box;
    padding: 12px 44px 12px 20px;
    background: #5562C0;
    color: #ffffff;
    font-size: 14px;
    line-height: 1.4;
    text-align: center;

    a {
        color: #ffffff;
        text-decoration: underline;
        white-space: nowrap;
    }
`;

const BannerClose = styled.div`
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
`;

/**
 * Warns users on an outdated desktop Chrome that their outbound audio/video may
 * silently fail to reach the other participants.
 *
 * Renders nothing unless the user is on desktop Google Chrome *and* their major
 * version is below `window.chrome_min_version` (set from the CHROME_MIN_VERSION
 * env var). Every unknown — missing global, unrecognized user-agent — resolves
 * to rendering nothing.
 *
 * Dismissal is deliberately component state only: no storage, no cookie. The
 * banner returns on every page load until the user actually updates Chrome.
 */
const BrowserUpdateBanner = () => {
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) {
        return null;
    }

    const minVersion = Number(window.chrome_min_version) || 0;
    const version = chromeMajorVersion(
        typeof navigator === 'undefined' ? '' : navigator.userAgent
    );

    if (version === null || version >= minVersion) {
        return null;
    }

    return (
        <Banner>
            <strong>Your Chrome is out of date (version {version}).</strong>
            {' '}On older versions of Chrome your teacher may not be able to see
            or hear you.{' '}
            <a href={CHROME_UPDATE_URL} target="_blank" rel="noopener noreferrer">
                Update Chrome &rarr;
            </a>
            <BannerClose onClick={() => setDismissed(true)}>X</BannerClose>
        </Banner>
    );
};

export default BrowserUpdateBanner;
